'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import DealTypeTabs from '@/app/cc/_component/ui/section/MainVisual/DealTypeTabs';
import styles from '@/app/cc/_component/ui/section/MainVisual/MainVisual.module.scss';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';
export default function MainVisual() {
  const $ = _c(19);
  const dealType = useGetDealType();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.badgeIcon}><Image src="/cc/image/icon_shield.svg" alt="shield_icon" fill={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = dealType === "sale" ? "\uB0B4 \uBD80\uB3D9\uC0B0, \uC548\uC804\uD558\uAC8C \uC9C0\uD0A4\uB294 \uBC29\uBC95\u200B" : "\uB0B4 \uBCF4\uC99D\uAE08, \uC548\uC804\uD558\uAC8C \uC9C0\uD0A4\uB294 \uBC29\uBC95";
  let t2;
  if ($[1] !== t1) {
    t2 = <div className={styles.badge}>{t0}<Text category="heading" variant="sb3" color="var(--color-red-500)">{t1}</Text></div>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p>예고 없이 찾아오는 부동산 사기!</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className={styles.mainVisualTitleText}>{t3}<p>전 재산이 걸린 계약,<br className="break" /><span className={styles.highlightText}> 대비하셨나요?</span></p></h2>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2) {
    t5 = <div>{t2}{t4}</div>;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br className="break" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text as="p" category="title" variant="m3" color="var(--color-gray-700)">부동산 계약부터 다음 이사 때까지,{t6}안전은 이실장 안심케어에 맡기세요.{t7}비용은 <b>단 한 번으로 충분</b>해요.</Text>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5) {
    t9 = <div className={styles.mainVisualContent}>{t5}{t8}</div>;
    $[10] = t5;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={styles.mainVisualImageContainer}><div className={styles.mainVisualImage}><Image src="/cc/image/main/main_visual.svg" alt="MainVisual" priority={true} fill={true} /></div></div>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className={styles.desktopDealTypeContainer}><DealTypeTabs /></div>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t9) {
    t12 = <div className={styles.innerContent}>{t9}{t10}{t11}</div>;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className={styles.mobileDealTypeContainer}><DealTypeTabs /></div>;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12) {
    t14 = <section className={styles.mainVisual}>{t12}{t13}</section>;
    $[17] = t12;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  return t14;
}